export function formatObjectFields(propertyDetails, importantKeys) {

    let result = '';

    // Loop over each key and if it exists in the propertyDetails, add it to the result string.
    importantKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(propertyDetails, key)) {
            result += `${key}: ${propertyDetails[key]}\n`;
        }
    });

    return result;
}


// List of keys considered important for building details.
export const buildingFieldsToInclude = [
    "BIN",
    "Borough",
    "BuildingsonLot",
    "CensusTract",
    "CityOwned",
    "Condo",
    "CrossStreet1",
    "CrossStreet1Numbers",
    "HouseNo",
    "StreetName",
    "StreetNumbers",
    "TaxBlock",
    "TaxLot",
    "Zip",
    "SpecialDistrict"
];


export const deviceFieldsToInclude = [
    "device_number",
    "device_type",
    "device_status",
    "status_date",
    "periodic_report_year",
    "cat1_report_year",
    "cat1_latest_report_filed",
    "cat5_latest_report_filed",
    "periodic_latest_inspection",
    "bin",
    "borough",
    "house_number",
    "street_name",
    "block",
    "lot",
    "zip_code"
];

export const transformBuildingDetails = (details) => {
    // Map numeric borough codes to county names.


    const boroughMap = {
        1: "Manhattan",
        2: "Bronx",
        3: "Brooklyn",
        4: "Queens",
        5: "Staten Island"
    };


    // Build a reference string.
    // If available, use the StreetNumbers plus StreetName; otherwise fall back to HouseNo.
    // const buildingReference =
    //     details.StreetNumbers && details.StreetName ? `${details.StreetNumbers} ${details.StreetName}` : details.HouseNo && details.StreetName ? `${details.HouseNo} ${details.StreetName}` : null;

    // get addressLine1 and addressLine2
    // from buildingReference

    const buildingReference = details.StreetNumbers && details.StreetName ? `${details.StreetNumbers} ${details.StreetName}` : details.HouseNo && details.StreetName ? `${details.HouseNo} ${details.StreetName}` : null;

    


    return {
        // buildingID will be added later.
        buildingID: null,
        buildingReference: buildingReference,
        buildingType: null, // Not provided in details; adjust as needed.
        customerID: null,   // Not available.
        buildingStatus: "Active", // Default value.
        location: boroughMap[details.Borough] || null,
        territory: null,
        buildingZone: details.SpecialDistrict || null,
        billingCode: null,
        billingClass: null,
        agencyID: null,
        dispatchType: "Standard", // Default value.
        block: details.TaxBlock || null,
        lot: details.TaxLot || null,
        mainPhone: null,
        buildingAdded: null,
        buildingNote: "",
        agentID: null,
        emailAddress: null,
        websiteAddress: null,
        routeID: null,
        salesRep: null,
        numberOfSiteDevices: null,
        numberOfContractDevices: null,
        siteBillingType: null,

        taxDetailID: null,
        salesIndexService: null,
        salesIndexProposal: null,
        salesIndexMaintenance: null,
        salesIndexParts: null,
        paymentRating: null,
        userDate: null,
        userID: null,
        lastEditDate: null,
        lastUserID: null,
        latitude: null,
        longitude: null,
        lastUpdated: null,
        addressCareOf: null,
        addressLine1: buildingReference,
        addressLine2: "",
        city: boroughMap[details.Borough] || null,
        state: "NY",
        zip: details.Zip || null,
        billingAddressCareOf: null,
        billingAddressLine1: null,
        billingAddressLine2: "",
        billingCity: null,
        billingState: null,
        billingZip: null
    };
}






export const transformDeviceDetails = (device) => {
    // Generate an address by merging house number and street name if available.
    const address = device.house_number && device.street_name
        ? `${device.house_number} ${device.street_name}`
        : null;

    return {
        // deviceId will be added later.
        deviceId: null,
        deviceType: device.device_type || null,
        deviceStatus: device.device_status || null,
        deviceUse: null,            // Not provided in the source.
        deviceDomain: null,         // Not provided.
        block: device.block || null,
        bin: device.bin || null,
        address: address,
        building: null,             // Not provided.
        borough: device.borough || null,
        buildingId: null,              // Default value; update as needed.
        buildingSite: null,         // Not provided.
        customerId: null,              // Default value.
        managementId: null,            // Default value.
        buildingType: null,         // Not provided.
        coverage: null,             // Not provided.
        cat1Insp: device.cat1_latest_report_filed || null,
        cat5Insp: device.cat5_latest_report_filed || null,
        periodicInsp: device.periodic_latest_inspection || null,
        siteNumber: null,           // Not provided.
        deviceBank: null,           // Not provided.
        deviceGroup: null,          // Not provided.
        isKeyDevice: null,          // Not provided.
        deviceName: device.device_number || null,
        deviceTypeDdl: null,        // Not provided.
        machineType: null,          // Not provided.
        dobType: null,              // Not provided.
        capacity: null,             // Not provided.
        passengerCount: null,       // Not provided.
        carSpeed: null,             // Not provided.
        deviceClass: null,          // Not provided.
        currentSubclass: null,      // Not provided.
        deviceSubclass: null,       // Not provided.
        travel: "1",                // Default value as in your example.
        landingCount: null,         // Not provided.
        floorCount: null,           // Not provided.
        floorsServed: null,         // Not provided.
        machineRoomLocation: null,  // Not provided.
        buildingPower: null,        // Not provided.
        controllerOperation: null,  // Not provided.
        carOperation: null,         // Not provided.
        fireService: null,          // Not provided.
        handicappedStatus: null,    // Not provided.
        originalDate: device.status_date || null,
        manufacturer: null,         // Not provided.
        lastModernized: null,       // Not provided.
        freeMaintenanceEnd: null,   // Not provided.
        cabConfigurationType: null, // Not provided.
        recordId: null,             // Not provided.
        carNotes: null,             // Not provided.
        lastUpdated: new Date().toISOString() // Current timestamp.
    };
}